<template>
  <v-layout wrap pt-2>
    <v-flex xs12 sm6 md12>
      <div class="Black--text mb-2">
        <div class="red--background font-weight-bold left" primary-title>
          Validating Parameters:
        </div>

        <br />
        <v-layout wrap v-if="question.option_validating_parameter">
          <v-flex xs12 v-if="question.option_validating_parameter.max"
            ><span class="font-weight-bold"> Max: </span>
            {{ question.option_validating_parameter.max }}
          </v-flex>

          <v-flex xs12 v-if="question.option_validating_parameter.min"
            ><span class="font-weight-bold">Min: </span
            >{{ question.option_validating_parameter.min }}
          </v-flex>

          <v-flex xs12 v-if="question.option_validating_parameter.exactly"
            ><span class="font-weight-bold">Exactly: </span>
            {{ question.option_validating_parameter.exactly }}
          </v-flex>

          <v-flex
            xs12
            v-if="question.option_validating_parameter.custom_message"
            ><b class="font-weight-bold">Custom Message: </b>
            {{ question.option_validating_parameter.custom_message }}
            >
          </v-flex>
        </v-layout>
        <v-layout wrap v-if="question.number_validating_parameter">
          <v-flex xs12 v-if="question.number_validating_parameter.max"
            ><span class="font-weight-bold">Max: </span>
            {{ question.number_validating_parameter.max }}
          </v-flex>

          <v-flex xs12 v-if="question.number_validating_parameter.min"
            ><span class="font-weight-bold">Min: </span>
            {{ question.number_validating_parameter.min }}
          </v-flex>

          <v-flex xs12 v-if="question.number_validating_parameter.exactly"
            ><span class="font-weight-bold">Exactly: </span>
            {{ question.number_validating_parameter.exactly }}
          </v-flex>

          <v-flex
            xs12
            v-if="question.number_validating_parameter.custom_message"
            ><span class="font-weight-bold">Custom Message: </span>
            {{ question.number_validating_parameter.custom_message }}
          </v-flex>
        </v-layout>
        <v-layout wrap v-if="question.image_validating_parameter">
          <v-flex
            xs12
            v-if="question.image_validating_parameter.max_number_of_images"
            ><span class="font-weight-bold">Number of images: </span>
            {{ question.image_validating_parameter.max_number_of_images }}
          </v-flex>

          <v-flex xs12 v-if="question.image_validating_parameter.allow_selfie"
            ><span class="font-weight-bold">Allow selfie: </span> Yes
          </v-flex>

          <v-flex xs12 v-if="question.image_validating_parameter.only_camera"
            ><span class="font-weight-bold">Only camera:</span> Yes
          </v-flex>
        </v-layout>
        <v-layout wrap v-if="question.file_validating_parameter">
          <v-flex xs12 v-if="question.file_validating_parameter.max"
            ><span class="font-weight-bold">Max:</span>
            {{ question.file_validating_parameter.max }}
          </v-flex>

          <v-flex xs12 v-if="question.file_validating_parameter.live_record"
            ><span class="font-weight-bold">Live record:</span> Yes
          </v-flex>

          <v-flex xs12 v-if="question.file_validating_parameter.file_types"
            ><span class="font-weight-bold">File types:</span>
            {{ question.file_validating_parameter.file_types }}
          </v-flex>
        </v-layout>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: ["question"],

  computed: {
    ...mapGetters([
      "isLoggedIn",
      "indexData",
      "error",
      "statusCode",
      "errorMsg",
    ]),
    binding() {
      const binding = {};
      if (this.$vuetify.breakpoint.mdAndUp) binding.column = true;

      return binding;
    },
  },

  created() {
    // console.log("ok");
    // this.$store.dispatch("setIndexData", [this.apiUrl]);
    // this.editedData();
    // this.questionLogic=JSON.parse(this.question_logic);
    // console.log(this.questionLogic);
    // console.log(this.questions);
  },

  methods: {},
};
</script>

<style scoped>
.headline {
  color: white;
}
.project {
  background: #ff2e2e;
}
</style>
